<script setup lang="ts">
    import LoadingDots from './LoadingDots.vue';

    withDefaults(defineProps<{ show?: boolean }>(), { show: true });
</script>

<template>
    <Transition name="fade" :duration="125">
        <div
            v-if="show"
            class="bg-white/60 absolute rounded-lg w-full h-full inset-0 z-50 animate-fadeIn"
        >
            <div class="sticky top-0 flex justify-center items-center w-full h-screen max-h-full">
                <LoadingDots />
            </div>
        </div>
    </Transition>
</template>
